exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".from-button {\n  font-size: 1.2vw;\n  font-weight: 600;\n  line-height: .6em;\n  color: white;\n  width: 12em;\n  border-radius: .5rem;\n  text-align: center;\n  padding: .8rem;\n  margin-right: .5em; }\n  .from-button.submit {\n    opacity: .8;\n    background-color: #ff4a50;\n    border: 1px solid #f2f5fe; }\n    .from-button.submit:hover {\n      opacity: 1; }\n    .from-button.submit:disabled {\n      opacity: .5; }\n  .from-button.cancel {\n    border: 2px solid #dde2ec;\n    color: #484848; }\n    .from-button.cancel:hover {\n      background: #dde2ec; }\n", ""]);

// exports
